/**
 * <TimezonePickerSkeleton> — la forme de la liste des fuseaux pendant qu'elle arrive.
 *
 * Une carte-liste de lignes de réglage à leur hauteur (la cible du doigt de `<SettingRow>`) : le
 * rond de l'icône, la ville, la région calée à droite.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Skeleton } from "../../atoms/Skeleton"
import { CardList, CardListRow } from "../../molecules/CardList"
import { SETTING_ROW_MIN_HEIGHT } from "../../molecules/SettingRow/SettingRow"

/** Cinq villes de longueurs différentes, comme une vraie liste. */
const CITY_WIDTHS = [90, 130, 70, 150, 110]

export function TimezonePickerSkeleton() {
    return (
        <CardList>
            {CITY_WIDTHS.map((width) => (
                <CardListRow key={width} py="1">
                    <Row gap="3" align="center" style={styles.row}>
                        <Skeleton shape="circle" size={20} />
                        <Skeleton textSize="text-base" width={width} />
                        <View style={styles.spacer} />
                        <Skeleton textSize="text-md" width={60} />
                    </Row>
                </CardListRow>
            ))}
        </CardList>
    )
}

const styles = StyleSheet.create(() => ({
    row: { minHeight: SETTING_ROW_MIN_HEIGHT },
    spacer: { flexGrow: 1 },
}))
